import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { Database, Settings } from 'lucide-react';

const DatabaseNode = ({ data, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  
  return (
    <>
      <div className={`px-4 py-2 shadow-md rounded-lg bg-green-500 text-white border-2 ${
        selected ? 'border-green-300' : 'border-green-600'
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Database className="h-4 w-4" />
            <div className="text-sm font-medium">{data.label}</div>
          </div>
          <button
            onClick={() => setShowConfig(true)}
            className="p-1 hover:bg-green-600 rounded"
          >
            <Settings className="h-3 w-3" />
          </button>
        </div>
        
        {data.config?.operation && (
          <div className="text-xs mt-1 opacity-90">
            {data.config.operation}: {data.config.table}
          </div>
        )}
        
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: '#22c55e',
            border: '2px solid #16a34a',
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          style={{
            background: '#22c55e',
            border: '2px solid #16a34a',
          }}
        />
      </div>

      {showConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Configure Database Node</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Operation</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>SELECT</option>
                  <option>INSERT</option>
                  <option>UPDATE</option>
                  <option>DELETE</option>
                  <option>BULK INSERT</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Table/Collection</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>candidates</option>
                  <option>job_requisitions</option>
                  <option>pipeline_stages</option>
                  <option>workflows</option>
                  <option>open_requests</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Query/Filter</label>
                <textarea 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="WHERE clause or MongoDB query..."
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Fields</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="id, name, email (comma separated)"
                />
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-6">
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DatabaseNode;